import { Component, Input, OnDestroy, OnInit, inject } from '@angular/core';
import { SmartwatchDashboardConfiguration } from './smartwatch-dashboard-configuration';
import { RouterLink } from '@angular/router';
import { CardBarComponent } from '../../../../components/card-bar/card-bar.component';
import { LoadingIndicatorComponent } from '@nimmsta/ng-commons-lib/loading-indicator';
import { SmartwatchService } from '../../../../services/smartwatch.service';
import { CardDataItem } from '../../../../models/cardDataItem';
import { DashboardComponentInterface } from '../../../../models/dashboard';

@Component({
  selector: 'app-smartwatch-dashboard',
  templateUrl: './smartwatch-dashboard.component.html',
  imports: [RouterLink, CardBarComponent, LoadingIndicatorComponent],
})
export class SmartwatchDashboardComponent
  implements OnInit, OnDestroy, DashboardComponentInterface
{
  private smartwatchService = inject(SmartwatchService);
  @Input() configuration!: SmartwatchDashboardConfiguration;

  intervalTime = 10000;

  protected smartwatchData: CardDataItem[] = [new CardDataItem('Loading', 0)];

  protected isLoading = false;

  private isFirstLoad = true;

  private interval?: ReturnType<typeof setInterval> = undefined;

  ngOnInit() {
    this.interval = setInterval(() => this.loadData(), this.intervalTime);
  }

  ngOnDestroy() {
    clearInterval(this.interval);
  }

  setConfiguration(configuration: unknown): void {
    this.configuration = {
      ...this.configuration,
      ...(configuration as object),
    };
  }

  loadData() {
    if (this.isFirstLoad) {
      this.isFirstLoad = false;
      this.isLoading = true;
    }
    this.smartwatchService.getSmartwatchStatus().subscribe((count) => {
      this.smartwatchData = count.map(
        (item) => new CardDataItem(item.status, item.count),
      );
      this.isLoading = false;
    });
  }
}
